// https://wiki.yandex-team.ru/messenger/product/features/letteravatars/

const REG_MONOGRAM_SPLIT = /[\s.,;_-]/i;
const REG_NOT_ALLOWED_CHAR = /[^a-zа-яё0-9]/gi;

/**
 * @param {string} str
 * @returns {string}
 */
function getFirstAllowedChar(str: string): string {
    return str.replace(REG_NOT_ALLOWED_CHAR, '')[0] || '';
}

/**
 * https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/String/charAt
 *
 * @param {string} str
 * @param {number} index
 * @returns {string}
 */
function fixedCharAt(str: string, index: number): string {
    let result = '';
    let pos = index;

    const surrogatePairs = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    while (surrogatePairs.exec(str) !== null) {
        if (surrogatePairs.lastIndex - 2 < pos) {
            pos++;
        } else {
            break;
        }
    }

    if (pos >= str.length || pos < 0) {
        return '';
    }

    result += str.charAt(pos);

    if (/[\uD800-\uDBFF]/.test(result) && /[\uDC00-\uDFFF]/.test(str.charAt(pos + 1))) {
        // Перешагиваем через один, поскольку один «символ» является частью суррогатной пары
        result += str.charAt(pos + 1);
    }

    return result;
}

/**
 * Возвращает монограмму на основе строки.
 *
 * @param {string} str
 * @returns {string}
 */
export const getMonogram = (str = ''): string => {
    const parts = str
        .trim()
        .split(REG_MONOGRAM_SPLIT)
        .filter((part) => part);

    switch (parts.length) {
        case 0:
            return '';
        case 1: {
            const firstChar = getFirstAllowedChar(parts[0]);
            if (firstChar) {
                return firstChar.toUpperCase();
            }
            break;
        }
        default: {
            const firstChar = getFirstAllowedChar(parts[0]);
            const secondChar = getFirstAllowedChar(parts[parts.length - 1]);

            if (firstChar || secondChar) {
                return `${firstChar}${secondChar}`.toUpperCase();
            }

            break;
        }
    }

    const result = str.replace(/\s/g, '');

    // Корректно обрабатываем суррогатные пары.
    return fixedCharAt(result, 0) + fixedCharAt(result, 1);
};
